import { SPACING_VALUES } from '@/utils';
import { ProductsDisplayBreakpoints, ProductsDisplaySpacing } from '@/types';

/** Column counts aligned with Products carousel / CollectionTreez kiosk grid. */
const KIOSK_CAROUSEL_DEFAULT_COLS: Record<number, number> = {
  0: 1,
  420: 2,
  640: 3,
  783: 3,
  1114: 4,
  1332: 5,
  1550: 6,
  1768: 7,
  1986: 8,
  2204: 9,
};

/** Matches `kiosk-collection-grid-large` in CollectionTreez.module.scss. */
const KIOSK_CAROUSEL_LARGE_COLS: Record<number, number> = {
  0: 1,
  420: 2,
  640: 2,
  896: 3,
  1332: 4,
  1640: 5,
  1986: 6,
  2204: 7,
  2422: 8,
};

const getSpaceBetweenForWidth = (
  width: number,
  spacing: ProductsDisplaySpacing,
): number => {
  const selectedSpacing = SPACING_VALUES[spacing] ?? SPACING_VALUES.small;

  if (width >= 1986) return selectedSpacing.xxl;
  if (width >= 1280) return selectedSpacing.xl;
  if (width >= 768) return selectedSpacing.sm;

  return selectedSpacing.default;
};

const buildKioskCarouselBreakpoints = ({
  isKioskLargeCard = false,
  spacingBetweenCard,
  spaceBetween,
}: {
  isKioskLargeCard?: boolean;
  spacingBetweenCard: ProductsDisplaySpacing;
  /** When set, used for every breakpoint (keeps Swiper in sync with CSS gap). */
  spaceBetween?: number;
}): ProductsDisplayBreakpoints => {
  const columnMap = isKioskLargeCard
    ? KIOSK_CAROUSEL_LARGE_COLS
    : KIOSK_CAROUSEL_DEFAULT_COLS;

  return Object.fromEntries(
    Object.entries(columnMap).map(([width, cols]) => [
      Number(width),
      {
        slidesPerView: cols,
        spaceBetween:
          spaceBetween ??
          getSpaceBetweenForWidth(Number(width), spacingBetweenCard),
      },
    ]),
  );
};

export {
  KIOSK_CAROUSEL_DEFAULT_COLS,
  KIOSK_CAROUSEL_LARGE_COLS,
  buildKioskCarouselBreakpoints,
};
